export default __webpack_public_path__ + "static/media/header__background.736fc3c7.png";